import React from 'react';

import {
  SaveButton,
  NumberInput,
  required,
  minValue,
  maxValue,
  useRecordContext,
  TextInput,
  DeleteButton,
  RecordContextProvider,
  usePermissions,
  Labeled,
  TextField,
} from 'react-admin';

import {
  Box,
  Grid,
} from '@mui/material';

import { useFormContext } from 'react-hook-form';

import EditDialog from '../layout/dialog/EditDialog';
import actions, { Actions } from '../../constants/actions';
import resourceTypes from '../../constants/resourceTypes';
import hasAccess from '../../utilities/hasAccess';

const CustomToolbar = () => {
  const { formState: { isValid } } = useFormContext();
  const { permissions } = usePermissions<Actions[]>();

  return (
    <Box display="flex" justifyContent="space-between" gap={2} marginTop={6}>
      {hasAccess(permissions, actions.RISK_CLASS_DELETE) && (
        <DeleteButton />
      )}
      {hasAccess(permissions, actions.RISK_CLASS_UPDATE) && (
        <SaveButton
          disabled={!isValid}
          icon={null as any}
        />
      )}
    </Box>
  );
};

const RiskClassEdit = () => {
  const record = useRecordContext();

  return (
    <EditDialog
      customToolbar={<CustomToolbar />}
      title="risk class"
      action={actions.RISK_CLASS_GET}
      resourceType={resourceTypes.RISK_CLASS}
    >
      <RecordContextProvider value={record}>
        <Grid container spacing={6}>
          <Grid size={12}>
            <Labeled label="ID">
              <TextField source="id" />
            </Labeled>
          </Grid>
          <Grid size={12}>
            <Labeled label="Name">
              <TextInput validate={required()} source="name" label="" helperText={false} />
            </Labeled>
          </Grid>
          <Grid size={12}>
            <Labeled label="Minimum score (%)">
              <NumberInput validate={[required(), maxValue(99), minValue(0)]} source="min" label="" helperText={false} />
            </Labeled>
          </Grid>
          <Grid size={12}>
            <Labeled label="Maximum score (%)">
              <NumberInput validate={[required(), maxValue(100), minValue(1)]} source="max" label="" helperText={false} />
            </Labeled>
          </Grid>
        </Grid>
      </RecordContextProvider>
    </EditDialog>
  );
};

export default RiskClassEdit;
